import * as React from 'react'
import SVG from 'react-svg-inline'
import styled from 'styled-components'

import eyeIcon from '../../icons/common/show.svg'

const colors = {
  default: '#CDD8E5',
  red: '#F44336',
  green: '#9CCC65'
}

const Container = styled.label`
  width: ${props => props.width};
  height: 60px;
  display: flex;
  position: relative;
  margin-bottom: 20px;
  cursor: text;

  &:not(:focus-within):after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 10px;
    border: 1px solid
      ${props =>
        props.message && props.touched
          ? colors.red
          : !props.message && props.value
          ? colors.green
          : props.theme.color.background};
  }

  &:hover:not(:focus-within):after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 10px;
    border: 1px solid
      ${props =>
        props.message && props.touched
          ? colors.red
          : !props.message && props.value
          ? colors.green
          : props.theme.color.pale};
  }
`

const Input = styled.input`
  font-size: 16px;
  width: 100%;
  height: 100%;
  color: ${props => props.theme.color.mainFont};
  background-color: ${props => props.theme.color.background};
  border-radius: 10px;
  padding-left: ${props => (props.icon ? '55px' : '20px')};
  padding-top: 20px;
  outline: none;
  border: none;
  position: relative;
  display: flex;

  &::placeholder {
    opacity: 0;
    color: ${props => props.theme.color.disabled};
  }

  &:focus {
    background-color: ${props => props.theme.color.backgroundRush};
    border: 1px solid ${props => props.theme.color.background};
    padding-left: ${props => (props.icon ? '54px' : '19px')};

    &::placeholder {
      opacity: 1;
    }

    & ~ span {
      &:nth-of-type(1) {
        top: 12px;
        font-size: 12px;
        color: ${props => props.theme.color.gray};
      }

      &:nth-of-type(2) svg {
        fill: ${props => props.theme.color.gray};
      }
    }
  }
`

const Text = styled.span`
  position: absolute;
  left: ${props => (props.icon ? '55px' : '20px')};
  top: ${props => (props.value ? '12px' : '20px')};
  font-size: ${props => (props.value ? '12px' : '16px')};
  color: ${props =>
    props.message && props.touched
      ? colors.red
      : !props.message && props.value
      ? colors.green
      : props.value
      ? props.theme.color.gray
      : props.theme.color.mainFont};
  transition: 0.2s ease all;
`

const Icon = styled(SVG)`
  display: flex;
  position: absolute;
  left: 20px;
  top: 20px;
  svg {
    height: 20px;
    width: 20px;
    fill: ${props =>
      props.message && props.touched
        ? colors.red
        : !props.message && props.value
        ? colors.green
        : props.value
        ? props.theme.color.gray
        : props.theme.color.disabled};
  }
`

const Eye = styled(SVG)`
  position: absolute;
  right: 20px;
  top: 20px;
  display: flex;
  cursor: pointer;
  z-index: 1;

  svg {
    height: 20px;
    width: 20px;
    fill: ${props => props.theme.color.gray};
  }
`

const WarningText = styled.span`
  position: absolute;
  bottom: -20px;
  left: 0;
  font-size: 12px;
  color: ${colors.red};
`

export default ({
  width,
  text,
  input,
  type,
  placeholder,
  icon,
  meta: { active, error, warning, touched },
  switchDisplayPassword,
  showPassword
}) => {
  const { value } = input
  const message = !active ? error || warning : undefined
  showPassword ? (type = 'text') : (type = 'password')
  const inputProps = { ...input, type, placeholder }

  return (
    <Container width={width} message={message} value={value} touched={touched}>
      <Input icon={icon} {...inputProps} />
      <Text icon={icon} value={value} message={message} touched={touched}>
        {text}
      </Text>
      {icon && (
        <Icon
          message={message}
          value={value}
          svg={icon}
          touched={touched ? 1 : 0}
        />
      )}
      {value && (
        <Eye
          svg={eyeIcon}
          onMouseDown={switchDisplayPassword}
          onMouseUp={switchDisplayPassword}
        />
      )}
      {message && touched && <WarningText>{message}</WarningText>}
    </Container>
  )
}
